import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=3986639f&scoped=true&"
import script from "./tab3.vue?vue&type=script&lang=js&"
export * from "./tab3.vue?vue&type=script&lang=js&"
import style0 from "./tab3.vue?vue&type=style&index=0&id=3986639f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986639f",
  null
  
)

export default component.exports